import { Download, XCircle, CheckCircle2 } from "lucide-react";
import { Card, EmptyState, formatDateTime } from "../../ui";
import { formatCpfCnpj } from "../../../lib/masks";
import { formatBRL } from "./shared";

export function ReceiptList({ downloadPdf, filtered, items, setCancelling }) {
  return (
    <>
      {items === null ? (
        <div className="text-sm text-slate-500">Carregando...</div>
      ) : filtered.length === 0 ? (
        <EmptyState
          title="Nenhum recibo emitido"
          hint="Use o botão acima para emitir o primeiro recibo."
        />
      ) : (
        <Card>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[10px] uppercase tracking-wide text-slate-500">
                <tr>
                  <th className="text-left p-3">Nº</th>
                  <th className="text-left p-3">Beneficiário</th>
                  <th className="text-left p-3">Referente a</th>
                  <th className="text-right p-3">Valor</th>
                  <th className="text-left p-3">Status</th>
                  <th className="text-left p-3">Emissão</th>
                  <th className="text-left p-3">Emitido por</th>
                  <th className="text-right p-3">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr
                    key={r.id}
                    data-testid={`receipt-row-${r.id}`}
                    className={`border-t border-slate-100 ${
                      r.status === "cancelado"
                        ? "bg-rose-50/40 text-slate-500"
                        : "hover:bg-slate-50"
                    }`}
                  >
                    <td className="p-3 font-mono text-xs">{r.number}</td>
                    <td className="p-3">
                      <div className="font-medium">{r.payer_name}</div>
                      <div className="text-xs text-slate-500">
                        {r.payer_person_type === "PJ" ? "CNPJ" : "CPF"}:{" "}
                        {formatCpfCnpj(r.payer_document, r.payer_person_type)}
                      </div>
                    </td>
                    <td className="p-3 max-w-sm">
                      <div className="line-clamp-2 text-sm">{r.reason}</div>
                      {r.boleto_number && (
                        <div
                          data-testid={`receipt-boleto-${r.id}`}
                          className="mt-1 text-[11px] text-slate-500"
                        >
                          Boleto nº:{" "}
                          <span className="font-mono text-slate-700">
                            {r.boleto_number}
                          </span>
                        </div>
                      )}
                    </td>
                    <td className="p-3 text-right font-semibold text-[#002776]">
                      {formatBRL(r.amount)}
                    </td>
                    <td className="p-3">
                      {r.status === "cancelado" ? (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border border-rose-200 bg-rose-50 text-rose-700 text-[11px]">
                          <XCircle size={11} /> Cancelado
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border border-emerald-200 bg-emerald-50 text-emerald-700 text-[11px]">
                          <CheckCircle2 size={11} /> Emitido
                        </span>
                      )}
                    </td>
                    <td className="p-3 text-xs text-slate-600">
                      {formatDateTime(r.issued_at)}
                    </td>
                    <td className="p-3 text-sm">
                      <div className="font-medium leading-tight">
                        {r.issued_by_name || "—"}
                      </div>
                      {r.issued_by_role_label && (
                        <div className="text-[10px] uppercase tracking-wide text-slate-500 mt-0.5">
                          {r.issued_by_role_label.replace(" · ABLEMP", "")}
                        </div>
                      )}
                    </td>
                    <td className="p-3 text-right">
                      <div className="inline-flex gap-1">
                        <button
                          data-testid={`receipt-download-${r.id}`}
                          onClick={() => downloadPdf(r)}
                          title="Baixar PDF"
                          className="px-2 py-1 border border-slate-300 text-[10px] uppercase tracking-wide hover:border-[#002776] inline-flex items-center gap-1"
                        >
                          <Download size={11} /> PDF
                        </button>
                        {r.status !== "cancelado" && (
                          <button
                            data-testid={`receipt-cancel-${r.id}`}
                            onClick={() => setCancelling(r)}
                            title="Cancelar"
                            className="px-2 py-1 border border-rose-300 text-rose-700 text-[10px] uppercase tracking-wide hover:bg-rose-50 inline-flex items-center gap-1"
                          >
                            <XCircle size={11} /> Cancelar
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}

    </>
  );
}
